import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ProductCatalog } from '../../components/products/ProductCatalog';
import { Product } from '../../types/product';
import toast from 'react-hot-toast';

/**
 * Страница каталога товаров для клиента
 * Отображает доступные товары из номенклатуры
 */
export const ProductsPage: React.FC = () => {
    const navigate = useNavigate();

    const handleAddToCart = (product: Product) => {
        // Сохраняем товар в localStorage для передачи в CreateOrderPage
        const cartItems = JSON.parse(localStorage.getItem('pendingCartItems') || '[]');
        cartItems.push(product);
        localStorage.setItem('pendingCartItems', JSON.stringify(cartItems));

        // Показываем уведомление
        toast.success(`${product.name} добавлен в заявку`, {
            duration: 2000,
            icon: '🛒',
        });

        // Перенаправляем на страницу создания заявки
        setTimeout(() => {
            navigate('/client/orders/create');
        }, 500);
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <ProductCatalog onAddToCart={handleAddToCart} />
            </div>
        </div>
    );
};

export default ProductsPage;

